import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const FilterByChannel = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByChannelUsersFilter }
  } = localizedStrings;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await request.get('/channels');
      if (result) {
        const transformedResult = _.get(result, 'data.channels', []).map(
          item => ({
            label: item.name,
            value: item.id
          })
        );
        setOptions(transformedResult);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, channel: value });
        }}
        label={filterByChannelUsersFilter}
        options={options}
        value={filters.channel}
      />
    </div>
  );
};

FilterByChannel.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByChannel;
